function Loader() {
  return (
    <>
      <div className="overlay-2">
        <div className="pulse-wrap">
          {/* <div className="pulse"></div> */}
          {/* <div className="pulse-2">
            <span></span>
            <span></span>
          </div> */}
          {/* <div className="multi-spinner-container">
            <div className="multi-spinner">
              <div className="multi-spinner">
                <div className="multi-spinner">
                  <div className="multi-spinner">
                    <div className="multi-spinner">
                      <div className="multi-spinner"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          {/* <div>
            <div className="triple-spinner"></div>
          </div> */}
          <div className="fadeDots">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          {/* <div className="loader-wrapper">
            <div className="loader-container">
              <div className="loader-circle"></div>
              <div className="loader-circle"></div>
              <div className="loader-circle"></div>
              <div className="loader-shadow"></div>
              <div className="loader-shadow"></div>
              <div className="loader-shadow"></div>
            </div>
          </div> */}
          {/* <div className="universe">
            <div>
              <div></div>
            </div>
            <div>
              <div></div>
            </div>
          </div> */}
          {/* <div className="spinner-box">
            <div className="blue-orbit leo"></div>

            <div className="green-orbit leo"></div>

            <div className="red-orbit leo"></div>

            <div className="white-orbit w1 leo"></div>
            <div className="white-orbit w2 leo"></div>
            <div className="white-orbit w3 leo"></div>
          </div> */}

          {/* <div className="loader loader-7">
            <div className="line line1"></div>
            <div className="line line2"></div>
            <div className="line line3"></div>
          </div> */}

          {/* <div className="loader loader-17">
            <div className="css-square square1"></div>
            <div className="css-square square2"></div>
            <div className="css-square square3"></div>
            <div className="css-square square4"></div>
            <div className="css-square square5"></div>
            <div className="css-square square6"></div>
            <div className="css-square square7"></div>
            <div className="css-square square8"></div>
          </div> */}
        </div>
      </div>
    </>
  );
}
export default Loader;
